// extracted by mini-css-extract-plugin
export default {"dividerContainer":"LoginDivider_dividerContainer__UY3OB","dividerLine":"LoginDivider_dividerLine__GiNT+","dividerText":"LoginDivider_dividerText__8vK-f"};